/**
 * Generates a unique ID. Uses crypto.randomUUID() when available
 * (secure contexts / Node 19+), otherwise falls back to a Math.random
 * based UUID v4 that works everywhere including HTTP.
 */
export function generateId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}
